import { Box } from "@mui/material";
import PropTypes from "prop-types";

import InspectionTimeline from "modules/inspections/components/InspectionTimeline";
import SoftBox from "components/SoftComponents/SoftBox";
import { useState } from "react";
import InspectionPreviewCard from "modules/inspections/components/InspectionPreviewCard";

import inspectionAPI from "modules/inspections/api";
import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "@tanstack/react-query";

function DeviceInspectionHistoryTab({ user, device, deviceLayout, selectedOrg, userPermissions }) {

    inspectionAPI.loadToken(useAuth0());
    const [selectedInspection, setSelectedInspection] = useState(null);
    const [visitTypeFilter, setVisitTypeFilter] = useState("all");

    const viewUnresolved = userPermissions.includes("operations:unresolved");
    const showUnderReview = userPermissions.includes("operations:reviewer");

    const inspections = useQuery({
        queryKey: ['getInspectionsByStopID', device.stop.site_id, selectedOrg],
        queryFn: async () => {
            return await inspectionAPI.getInspectionsByStopID(device.stop.site_id);
        }
    });

    const inspectionsData = inspections?.data?.inspections || [];

    // Initialize status filter once at the parent view level
    const [statusFilter, setStatusFilter] = useState(() => {
        if (viewUnresolved) {
            if (inspectionsData.some(row => row.status === "unresolved")) {
                return "unresolved";
            }
            else if (showUnderReview && inspectionsData.some(row => row.status === "review")) {
                return "review";
            }
        }

        return "all";
    });

    return (
        <>
            {deviceLayout == "mobile" ? (
                <SoftBox height={'calc(100svh - 8.5rem - 16px)'} minHeight={"calc(100svh - 8.5rem - 16px)"} sx={{ overflowY: 'hidden' }}>
                    {selectedInspection != null ? (
                        <Box sx={{ height: '100%' }}>
                            <InspectionPreviewCard type={'inspection'} {...{ user, selectedInspection, setSelectedInspection }} />
                        </Box>
                    ) : (
                        <SoftBox sx={{ overflowY: "hidden", borderRadius: "10px", height: "100%" }}>
                            <InspectionTimeline
                                type={'inspection'}
                                isLoading={inspections.isLoading}
                                isError={inspections.error}
                                inspections_data={inspectionsData}
                                currentDevice={device}
                                {...{ user, selectedInspection, setSelectedInspection, statusFilter, setStatusFilter, visitTypeFilter, setVisitTypeFilter }}
                            />
                        </SoftBox>
                    )}
                </SoftBox>
            ) : (
                <SoftBox height={"calc(100svh - 10.25rem - 16px)"}>
                    <SoftBox sx={{ overflowY: "hidden", borderRadius: "10px", height: "100%" }}>
                        <InspectionTimeline
                            type={'inspection'}
                            isLoading={inspections.isLoading}
                            isError={inspections.error}
                            inspections_data={inspectionsData}
                            currentDevice={device}
                            {...{ user, selectedInspection, setSelectedInspection, statusFilter, setStatusFilter, visitTypeFilter, setVisitTypeFilter }}
                        >
                            <InspectionPreviewCard type={'inspection'} {...{ user, selectedInspection, setSelectedInspection }} />
                        </InspectionTimeline>
                    </SoftBox>
                </SoftBox>
            )}
        </>
    );
}

DeviceInspectionHistoryTab.propTypes = {
    user: PropTypes.object,
    device: PropTypes.object,
    deviceLayout: PropTypes.string,
    selectedOrg: PropTypes.string,
    userPermissions: PropTypes.array,
}

export default DeviceInspectionHistoryTab;